module.exports = __webpack_public_path__ + "img/stock1.79a5e849.png";